export default __webpack_public_path__ + "static/bosch-logo.e93ee59e.svg";